import React, { InputHTMLAttributes } from 'react';

import { Checkmark } from '@/assets/images';

import './Checkbox.scss';

interface Props extends InputHTMLAttributes<HTMLInputElement> {
	text?: string | string[];
	variant?: 'default' | 'chip';
	hoverText?: string;
	advancedFilter?: boolean;
	lastPosition?: boolean;
}

const Checkbox = ({
	onClick,
	onChange,
	checked,
	defaultChecked,
	className,
	id,
	text,
	variant = 'default',
	hoverText,
	advancedFilter,
	lastPosition
}: Props): JSX.Element =>
	text ? (
		<div className="checkbox-div">
			{variant === 'default' && (
				<span
					className={`leading-none checkbox${className ? ` ${className}` : ''}`}
				>
					<label
						className="inline-flex cursor-pointer flex-row items-center"
						htmlFor={id}
					>
						<input
							id={id}
							type="checkbox"
							className="mr-2 cursor-pointer rounded border-0 p-0"
							onClick={e => {
								if (onClick) {
									onClick(e);
								}
							}}
							onChange={onChange}
							checked={checked}
							defaultChecked={defaultChecked}
						/>

						<span>{text}</span>
					</label>
				</span>
			)}
			{variant === 'chip' && (
				<span
					className={`inline-block leading-none checkbox-chip${
						defaultChecked ? 'checkbox-chip-checked' : ''
					}${className ? ` ${className}` : ''}`}
				>
					<label
						className="inline-flex cursor-pointer flex-row items-center rounded-3xl border px-3 py-1"
						htmlFor={id}
					>
						<input
							id={id}
							type="checkbox"
							className="hidden"
							onClick={e => {
								if (onClick) {
									onClick(e);
								}
							}}
							onChange={onChange}
							checked={checked}
							defaultChecked={defaultChecked}
						/>

						<span className="inline-flex items-center">
							{defaultChecked && (
								<Checkmark width={12} className="mr-1" />
							)}
							{text}
						</span>
					</label>
					{!advancedFilter && (
						<div
							className={`checkbox-chip-hover-text ${
								lastPosition ? 'last' : ''
							}`}
						>
							{hoverText}
						</div>
					)}
				</span>
			)}
		</div>
	) : (
		<input
			type="checkbox"
			className="checkbox-input inline-block cursor-pointer"
			onClick={e => {
				if (onClick) {
					onClick(e);
				}
			}}
			onChange={onChange}
			checked={checked}
		/>
	);

export default Checkbox;
